import { render, staticRenderFns } from "./Libraria.vue?vue&type=template&id=fefa0a9e&scoped=true"
import script from "./Libraria.vue?vue&type=script&lang=js"
export * from "./Libraria.vue?vue&type=script&lang=js"
import style0 from "./Libraria.vue?vue&type=style&index=0&id=fefa0a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefa0a9e",
  null
  
)

export default component.exports